import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import EasyTable from '../../EasyTable';
import EditableDetail from '../EditableDetail';
import FileDropzoneContainer from '../../../../containers/projectmanager/FileDropzoneContainer';
import PMAssignmentSection from '../PMAssignmentSection';
import EditableAdditionalDetail from '../EditableAdditionalDetail';
import PMContactSection from '../PMContactSection';
import InputText from '../../../blueprintWrappers/InputText';

class PMPhase extends Component {

	render() {
		const p = this.props;
		return (
			<div className={"PMPhase page"}>

				<div className={"topheader"}>
					<div className={"topheader_left"}>

					</div>
					<div className={"topheader_right"}>

					</div>
				</div>

				<div className="content">
					<div className="content_center">
						<div className={"content_header"}>

							<div className={"content_header_helper"}>
								<div onClick={p.goBack}><span className="icon">&#x25C0;</span>{"Back"}</div>
							</div>
						</div>

						<div className={"content_panel"}>
							{this.notifications()}
							{this.details()}
							{this.additionalDetails()}
						</div>

						<div className={"content_panel"}>
							{this.taskGroups()}
						</div>
						<div className={"content_panel"}>
							{this.assigned()}
						</div>
						<div className={"content_panel"}>
							{this.contacts()}
						</div>
						<div className={"content_panel"}>
							{this.attachments()}
						</div>

					</div>
				</div>

			</div>
		);
	}

	notifications = () => {
		const p = this.props;
		const { saved } = p.state;

		return <div>
			{saved ?
				null
				:
				<div style={{ backgroundColor: 'red' }}>
					This Phase has unsaved details
					<Button onClick={p.toggleSaved}>
						Save
				</Button>
				</div>
			}
		</div>
	}

	details = () => {
		const p = this.props;
		const { currentItem } = p.state;

		return (
			<div className={"PMPhaseDetails"}>
				<EditableDetail
					property={"display"}
					value={currentItem.display}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
				<EditableDetail
					small
					property={"description"}
					value={currentItem.description}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
				<h3>Project: {currentItem.project} | BP: {currentItem.bp}</h3>
			</div>
		)
	}

	additionalDetails = () => {
		const p = this.props;
		const { newCommentLine } = p.state;
		const { storedCommentLines } = p.reduxData;

		if (storedCommentLines.length === 0) {
			return (
				<div className={"AdditionalDetails"}>

					<InputText
						onChange={p.onChangeAdditionalDetail}
						value={newCommentLine.comment}
						returnObj={{ attr: "comment" }}
						placeholder={"Add a new detail"}
					/>

					<Button onClick={() => p.addAdditionalDetail()} >
						+ Add Additional Detail
					</Button>
				</div>
			)
		}

		return (
			<div className={"AdditionalDetails"}>
				{storedCommentLines.map((detail, index) => {
					return <EditableAdditionalDetail
						small
						value={detail}
						index={index}
						key={detail.uniqueID + '_editable_' + index}
						updateComment={p.updateComment}
					/>
				})}

				<InputText
					onChange={p.onChangeAdditionalDetail}
					value={newCommentLine.comment}
					returnObj={{ attr: "comment" }}
					placeholder={"Add a new detail"}
				/>

				<Button onClick={() => p.addAdditionalDetail()} >
					+ Add Additional Detail
				</Button>

			</div>
		)
	}

	taskGroups = () => {
		const p = this.props;
		const { filteredTGs } = p.state;

		return (
			<div >
				<EasyTable
					tableName={"Phase Dashboard (Task Groups)"}
					selectValue={'uniqueID'}
					headers={['Task Group', 'Due Date', 'Project Staff', 'Status']}
					show={['display', 'dueDate', 'assigned', 'status']}
					data={filteredTGs}
					onClick={p.selectTG}
					customColumns={['assigned']}
					renderCustomColumn={this.renderCustomColumn}
				>
					<Button onClick={p.addTaskGroup} >
						+ Add New Task Group
					</Button>
				</EasyTable>
			</div>
		)
	}

	renderCustomColumn = (property, row, i) => {
		switch (property) {
			case 'assigned':
				let usernames = [];
				row[property].forEach(element => {
					let loc = this.props.reduxData.storedUsers.findIndex(indexOfUser)

					if (loc > -1) {
						usernames.push(this.props.reduxData.storedUsers[loc].firstName + ' ' + this.props.reduxData.storedUsers[loc].lastName.substring(0, 1))
					}

					function indexOfUser(usr) {
						return usr.uniqueID === element;
					}
				});
				return <td key={i}>{usernames.join(", ")}</td>
			default:
				return <td key={i}>{row[property]}</td>
		}
	}

	assigned = () => {
		const p = this.props;
		const { assignedUsers } = p.state;

		return (
			<div className={"PMPhaseAssigned"}>
				<PMAssignmentSection
					users={assignedUsers}
					header={"Assigned Internal Users:"}
					addAssigned={p.addAssigned}
					removeAssigned={p.removeAssigned}
				/>
			</div>
		)
	}

	contacts = () => {
		const p = this.props;
		const { assignedContacts } = p.state;

		return (
			<div className={"PMProjectAssignedContacts"}>
				<PMContactSection
					users={assignedContacts}
					BPuniqueID={p.BPuniqueID}
					header={"Assigned Client Contacts:"}
					addAssignedContact={p.addAssignedContact}
					removeAssigned={p.removeAssignedContact}
				/>
			</div>
		)
	}

	attachments = () => {
		const p = this.props;
		return (
			<div className={"PMProjectAttachments"}>
				<h3>Attachments</h3>
				<FileDropzoneContainer />
			</div>
		)
	}
}

export default PMPhase;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/Phase/PMPhase.js